import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const SaleInvoicingUnprocessedSalesPageTourConfig: AgTechTourConfig = {
    id: 'sale-invoicing-unprocessed-page-tour',
    name: 'Unprocessed Sales Tour',
    steps: [
        {
            targetId: 'sale-invoicing-unprocessed-grid',
            title: 'Unprocessed Sales Grid',
            description: 'Shows all sold lots that haven\'t been invoiced yet, grouped by bidder. Use the action menu on a row to create an invoice for that bidder.',
            position: 'right',
        },
        {
            targetId: 'sale-invoicing-unprocessed-sales-metric',
            title: 'Unprocessed Sales',
            description: 'The number of bidders who have purchased lots but haven\'t received an invoice yet.',
            position: 'left',
        },
        {
            targetId: 'sale-invoicing-unprocessed-lots-metric',
            title: 'Sold Lots Not Invoiced',
            description: 'The total count of individual lots that are sold but still waiting to be invoiced.',
            position: 'left',
        },
        {
            targetId: 'sale-invoicing-unprocessed-total-metric',
            title: 'Total Not Invoiced',
            description: 'The combined purchase total for all uninvoiced lots — your outstanding amount to be invoiced.',
            position: 'left',
        },
    ]
}
